/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { SvgaChecklist } from '@coursera/coursera-ui/svg';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';

import _t from 'i18n!nls/degree-home';

import { calendarListFooterId, filterOptionValues } from './constants/constants';

const styles: Record<string, Interpolation<Theme>> = {
  emptyStateContainer: () => css`
    text-align: center;
    height: 60vh;
    margin-top: var(--cds-spacing-150);
  `,
  emptyStateMobileContainer: () => css`
    text-align: center;
    height: 15vh;
    margin-top: var(--cds-spacing-150);
  `,
  emptyStateIcon: () => css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

export const CalendarEmptyState = ({ mobile }: { mobile?: boolean }) => {
  const { filter } = useDegreeContext();
  const idPrefix = mobile ? 'mobile-' : '';
  let footerCopy;
  switch (filter) {
    case filterOptionValues.All:
      footerCopy = _t('You have no more Deadlines or Live Events');
      break;
    case filterOptionValues.Deadlines:
      footerCopy = _t('You have no more Deadlines');
      break;
    case filterOptionValues.LiveEvents:
      footerCopy = _t('You have no more Live Events');
      break;
    case filterOptionValues.Overdue:
      footerCopy = _t('You have no more Overdue items');
      break;
    default:
    // do nothing
  }

  return (
    <Grid
      data-e2e="calendar-empty-state"
      id={idPrefix + calendarListFooterId}
      item
      alignItems="center"
      xs={12}
      spacing={24}
      css={mobile ? styles.emptyStateMobileContainer : styles.emptyStateContainer}
    >
      <SvgaChecklist size={28} css={styles.emptyStateIcon} aria-hidden={true} />
      <Typography2 component="h3" variant="subtitleMedium">
        {_t("You're up to date")}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary">
        {footerCopy}
      </Typography2>
    </Grid>
  );
};

export default CalendarEmptyState;
